export default __webpack_public_path__ + "static/media/WhatsApp Image 2021-01-07 at 2.16.53 PM - 193_ABHINAV MUKHERJEE.b9d97266.jpeg";